import { render, staticRenderFns } from "./ViewMapLink.vue?vue&type=template&id=4a37b1f6&"
import script from "./ViewMapLink.vue?vue&type=script&lang=ts&"
export * from "./ViewMapLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports